import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { pick } from 'ramda';
import uuid from 'uuid-random';
import { useLiveGamesSelector } from 'js/store/hooks';
import { useUnmountEffect } from 'js/hooks/useUnmountEffect';
import { useLiveGamesSubscribe, useLiveGamesUnsubscribe } from 'js/hooks/useLiveGamesIntegration';

import * as actions from 'js/hooks/useLiveGamesIntegration/store/actions';

export const useLiveGames = (
    { liveLaunchAliases = [], preventSubscribe = false }: {
        liveLaunchAliases?: string[];
        preventSubscribe?: boolean;
    }
): void => {
    const dispatch = useDispatch();
    const correlationId = useRef<string | null>(null);
    const liveGamesSubscribe = useLiveGamesSubscribe();
    const liveGamesUnsubscribe = useLiveGamesUnsubscribe();
    const { isSocketConnected, isContextSucceeded } = useLiveGamesSelector(pick(['isSocketConnected', 'isContextSucceeded']));

    useEffect(() => {
        if (liveLaunchAliases.length) {
            dispatch(actions.startLiveIntegration());
        }
    }, [dispatch, liveLaunchAliases]);

    useEffect(() => {
        if (liveLaunchAliases.length && isSocketConnected && isContextSucceeded && !preventSubscribe) {
            if (correlationId.current) {
                liveGamesUnsubscribe({ correlationIds: [correlationId.current] });
            }

            correlationId.current = uuid();

            liveGamesSubscribe({
                correlationId: correlationId.current,
                tableAliases: liveLaunchAliases
            });
        }
    }, [
        liveLaunchAliases, liveGamesSubscribe, liveGamesUnsubscribe,
        isSocketConnected, preventSubscribe, isContextSucceeded
    ]);

    useUnmountEffect(() => {
        correlationId.current && liveGamesUnsubscribe({ correlationIds: [correlationId.current] });
    }, [liveGamesUnsubscribe]);
};
